var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bodycenter"},[_c('div',{staticClass:"x1",style:({height:_vm.height+'px'})},[_c('item',{staticClass:"xs",attrs:{"title":"热门停车场动态"}},[_c('vtable')],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }